import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import {
  Modal,
  Stack,
  Loader,
  Text,
  Group,
  ActionIcon,
  Checkbox,
  Center,
  AspectRatio,
  CopyButton,
} from "@mantine/core";

import { decode } from "@gandlaf21/bolt11-decode";

import { QRCodeSVG } from "qrcode.react";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import _ from "lodash";

import { Rizvoice } from "../stores/Rizvoice";
import { convertSatsToFiatString } from "../helpers/conversions";
import { Cubby } from "../stores/Cubby";

const GenericInvoiceQR = observer(
  ({
    modelInstance,
    invoiceString,
    whatIsItFor,
  }: {
    modelInstance: Cubby | Rizvoice;
    invoiceString: string;
    whatIsItFor: string;
  }) => {
    const decodedInvoice = decode(invoiceString);
    //console.log("decoded invoice", decodedInvoice);
    const invoiceValue = decodedInvoice.sections[2].value / 1000;

    return (
      <>
        <Stack gap="xs">
          <AspectRatio ratio={1}>
            <QRCodeSVG
              value={invoiceString}
              title={"Rizful Invoice For Inbound Channel"}
              size={300}
              bgColor={"#ffffff"}
              fgColor={"#000000"}
              level={"L"}
              marginSize={6}
            />
          </AspectRatio>

          <Text size="sm" ta="center">
            {whatIsItFor}: {invoiceValue.toLocaleString()} satoshis (
            {convertSatsToFiatString(invoiceValue, modelInstance)})
          </Text>

          <Text size="sm" ta="center">
            pay with any lightning-enabled Bitcoin wallet
          </Text>
          <Center>
            <Group gap="xs" align="center" mb="100px">
              <Text size="xs">{_.truncate(invoiceString, { length: 25 })}</Text>
              <CopyButton value={invoiceString}>
                {({ copied, copy }) => (
                  <ActionIcon
                    size="lg"
                    variant={copied ? "filled" : "default"}
                    color={copied ? "teal" : "blue"}
                    onClick={copy}
                    aria-label="copy address"
                  >
                    {copied ? <IconCheck /> : <IconCopy />}
                  </ActionIcon>
                )}
              </CopyButton>
            </Group>
          </Center>
        </Stack>
      </>
    );
  }
);

export default GenericInvoiceQR;
